import React, { useEffect, useState, useContext } from "react";
import { RuntimeConfigForm } from "../../Components/Display/RuntimeConfigForm";
import { useMsal } from "@azure/msal-react";
import { callApiWithAuthorization } from "../../API/CallApi";
import { useParams } from "react-router-dom";
import { getLoggedInUserUsingAccessToken } from "../../API/User/User";
import { PageContextProvider } from "../../Context/Display/Pages/PagesContext";
import { PropStoreProvider } from "../../Context/PropStore/PropStoreContext";
import { ComponentsContextProvider } from "../../Context/Display/Components/ComponentsContext";
import usePages, { useSelectedPage } from "../../Hooks/Display/usePages";
import useComponents, { useSelectedComponent } from "../../Hooks/Display/useComponents";
import { SELECT_PAGE, SET_PAGES } from "../../Context/Display/Pages/PagesContextEvents";
import { ConfirmationContextProvider } from "../../Components/Shared/ConfirmationWithContext/ConfirmationContext";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../Renderers/GlobalContext";

export const RuntimeConfigPage = () => {
    const context = useMsal();
    const params = useParams();

    let designerAccessToken = localStorage.getItem("accessToken");
    const { dispatch } = useContext(GlobalContext)

    const [state, setState] = useState({
        loading: true,
        loginAttempted: false,
        attemptLogin: false,
        authenticated: false,
        userVerified: true,
        isUserPartOfOrganisation: true,
        isUserPartOfProject: true,
        isEntityPartOfProject: true,
        isPagePartOfEntity: true,
        isComponentPartOfPage: true,
        organization: {},
        project: {},
        entity: {},
        page: {},
        component: {},
        user: {},
        Allcomponents: [],
        pages: [],
        error: {
            message: "",
            type: ""
        }
    });

    const { ready: tReady, i18n } = useTranslation();

    useEffect(() => {
        async function fetchData() {
            if (designerAccessToken) {
                await getUserUsingAccessToken();
                await getData();
                setState(prevState => ({
                    ...prevState,
                    loading: false,
                    authenticated: true
                }))
            } else {
                setState(prevState => ({
                    ...prevState,
                    loading: false,
                    authenticated: false,
                }))
            }
        }
        fetchData();
    }, [context.inProgress]);

    const getData = async () => {
        console.time("Overall");
        const {
            projectId,
            instanceId,
            entityId,
            pageId,
            componentId,
        } = params;

        try {
            console.time("new");
            const request = await callApiWithAuthorization("/api/v0/runtimeConfigData", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    organisationId: params.organisationId,
                    projectId,
                    entityId,
                    pageId,
                    componentId,
                }),
            });
            const response = await request.json();
            console.timeEnd("new");

            if (response.error !== undefined) {
                throw response
            }

            const {
                project,
                entity,
                pages,
                page,
                component,
                componentsForDropdown,
                userOrganization
            } = response;

            let organisationId = userOrganization.id
            let organisationName = userOrganization.number
            dispatch({ type: "SET_SUBSCRIPTION", payload: userOrganization ? userOrganization.subscription : {} })
            dispatch({ type: "SET_ORGANIZATION", payload: userOrganization || {} })
            dispatch({ type: "SET_USER", payload: userOrganization ? userOrganization.user : {} })
            setState(prevState => ({
                ...prevState,
                project,
                entity,
                page,
                component,
                instanceId,
                organization: userOrganization,
                organisationId,
                organisationName,
                Allcomponents: componentsForDropdown,
                pages,
                loginAttempted: false,
            }));
        } catch (e) {
            setState(prevState => ({
                ...prevState,
                loading: false,
                authenticated: true,
                error: {
                    message: e.error,
                    type: e.errorType
                }
            }))
        }
    }

    async function getUserUsingAccessToken() {
        const user = await getLoggedInUserUsingAccessToken();
        setState(prevState => ({
            ...prevState,
            user
        }))
    }

    useEffect(() => {
        if (tReady) {
            i18n.changeLanguage(state.organization.platformLanguage || "en");
        }
    }, [tReady, state.organization])

    const {
        loading,
        error
    } = state;

    if (loading) {
        return <div className="w-100 h-100">
            <div className="d-flex flex-column h-100">
                <div className="row">
                    <div className="col-10">
                        <div className="sk"></div>
                    </div>
                    <div className="col-2">
                        <div className="sk"></div>
                    </div>
                </div>
                <div className="sk flex-grow-1" style={{ marginTop: 10 }} ></div>
            </div>
        </div>
    }

    if (error.message && error.message !== "") {
        return (
            <div class="d-flex justify-content-center m-4">
                <div className="text-center">
                    <img
                        width={200}
                        alt="Progress-Loader"
                        src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/Error.png`}
                    />
                    <div className="font-size-2 mx-5 px-5">
                        {error.message}
                    </div>
                </div>
            </div>
        );
    }

    const { project, entity, page, component, user, instanceId } = state;

    const switchComponent = (dataItem) => {
        setState(prevState => ({
            ...prevState,
            component: dataItem
        }));
    }

    const updateComponentInTree = async (id, json) => {
        let { Allcomponents } = state
        let progressBars = []
        let index = Allcomponents.findIndex(component => component.id === id)
        if (index > -1) {
            Allcomponents[index].hidden = json.hidden === "true"
            if (json.order) {
                Allcomponents[index].order = json.order
            }
            Allcomponents[index].componentName = json.componentName
            const children = Allcomponents.filter(component => component.parentId === id)
            if (children.length > 0) {
                for (const child of children) {
                    child.hidden = json.hidden === "true"
                }
            }
        }
        if (Allcomponents[index].componentType === "Progress Bar") {
            progressBars.push(Allcomponents[index]);
        }
        if (progressBars.length > 0) {
            const progressBarIds = progressBars.map(
                (progressBar) => progressBar.id
            );
            const newProgressBarHiddenState = await handleProgressBarHiddenState(progressBarIds);
            for (const progressBar of progressBars) {
                progressBar.hidden = newProgressBarHiddenState;
            }
        }

        let finalArray = []

        if (Allcomponents[index].componentType === "Tab") {
            const tree = convertToTree(Allcomponents);
            updateTree(tree, id, json.order);
            finalArray = convertToArray(tree);
        } else {
            finalArray = Allcomponents
        }


        setState(prevState => ({
            ...prevState,
            Allcomponents: finalArray
        }));
    };

    // convert array to tree using element parent id
    const convertToTree = (array) => {
        const map = new Map();
        for (const item of array) {
            map.set(item.id, item);
        }
        const result = [];
        for (const item of array) {
            const parent = map.get(item.parentId);
            if (parent) {
                if (!parent.children) {
                    parent.children = [];
                }
                parent.children.push(item);
            } else {
                result.push(item);
            }
        }
        return result;
    };

    // update tree element order and sort by order
    const updateTree = (tree, id, order) => {
        for (const item of tree) {
            if (item.id === id) {
                item.order = order;
            } else if (item.children) {
                updateTree(item.children, id, order);
                item.children.sort((a, b) => a.order - b.order);
            }
        }
    };

    // convert tree to array
    const convertToArray = (tree) => {
        let array = [];
        for (const item of tree) {
            const { children, ...properties } = item;
            array.push(properties);
            if (children && children.length > 0) {
                array = array.concat(convertToArray(children));
            }
        }
        return array;
    };

    const handleProgressBarHiddenState = async (progressBarIds) => {
        const request = await callApiWithAuthorization(
            "/api/v0/page/" +
            state.page.id +
            "/handleProgressBarHiddenState",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    entityId: state.entity.id,
                    progressBarIds,
                }),
            }
        );
        const response = await request.json();
        return response.progressBarHiddenStatus;
    }

    return (
        <>
            <PropStoreProvider
                value={{
                    organisationId: state.organisationId,
                    advancedMode: state.project.developerMode === true,
                    orgName: state.organisationName,
                    projectId: state.project._id,
                    project: state.project,
                    entityId: state.entity._id,
                    entityName: state.entity.name,
                    entityLabel: state.entity.label,
                    selectedPageName: state.page.pageName,
                    selectedComponentId: state.component.id,
                    accessedFromDesigner: false
                }}
            >
                <PageContextProvider>
                    <ComponentsContextProvider>
                        <ConfirmationContextProvider>
                            <RuntimeConfigRender
                                updateComponentInTree={updateComponentInTree}
                                organisationId={state.organisationId}
                                organisationName={state.organisationName}
                                components={state.Allcomponents}
                                ChangeComponent={switchComponent}
                                pages={state.pages}
                                project={project}
                                entity={entity}
                                page={page}
                                user={user}
                                component={component}
                                instanceId={instanceId}
                            />
                        </ConfirmationContextProvider>
                    </ComponentsContextProvider>
                </PageContextProvider>
            </PropStoreProvider>
        </>
    );
}

function RuntimeConfigRender(props) {

    const [pageState, pageDispatch] = usePages();
    const [componentsState, componentsDispatch] = useComponents();

    const [selectComponentDispatched, setSelectComponentDispatched] = useState(false);
    const [showFormStatus, setShowFormStatus] = useState("LOADING");

    const selectedPage = useSelectedPage();

    useEffect(() => {
        const sortedPages = props.pages.sort((a, b) => a.order - b.order)
        pageDispatch({
            type: SET_PAGES,
            payload: [{
                id: sortedPages && sortedPages[0] ? sortedPages[0].parentId : "",
                pages: sortedPages
            }]
        })
        const pageIndex = props.pages.findIndex(page => page._id === props.page._id);
        pageDispatch({
            type: SELECT_PAGE,
            payload: "0_" + pageIndex
        })
        componentsDispatch({
            type: "SET_COMPONENTS",
            payload: props.components
        })
        const selectedComponentIndex = props.components.findIndex(component => component.id === props.component.id);
        componentsDispatch({
            type: "SET_SELECTED_COMPONENT",
            payload: String(selectedComponentIndex)
        })
        setSelectComponentDispatched(true);
    }, [])

    useEffect(() => {
        if (selectedPage && selectedPage.components && componentsState.selectedComponentIndex !== "") {
            componentsDispatch({
                type: "SET_COMPONENTS",
                payload: selectedPage.components
            })
        }
    }, [selectedPage])

    useEffect(() => {
        if (selectComponentDispatched && showFormStatus === "LOADING") {
            if (componentsState.components.length > 0) {
                const selectedComponent = componentsState.components[componentsState.selectedComponentIndex];
                if (selectedComponent) {
                    setShowFormStatus("SHOW_FORM");
                } else {
                    setShowFormStatus("NO_COMPONENT");
                }
            } else {
                setShowFormStatus("NO_COMPONENT");
            }
        }
    }, [selectComponentDispatched, componentsState.components])

    if (showFormStatus === "LOADING") {
        return (
            <div>
                Loading...
            </div>
        )
    }

    if (showFormStatus === "NO_COMPONENT") {
        return (
            <div>
                No component found
            </div>
        )
    }

    return (
        <RuntimeConfigForm
            updateComponentInTree={props.updateComponentInTree}
            organisationId={props.organisationId}
            organisationName={props.organisationName}
            components={props.components}
            ChangeComponent={props.ChangeComponent}
            project={props.project}
            entity={props.entity}
            page={props.page}
            user={props.user}
            component={props.component}
            instanceId={props.instanceId}
        />
    );
    // updatePublishErrorMessage={context.updatePublishErrorMessage}
}